import { getMethod, postMethod, putMethod, deleteMethod } from "../../api-service/api-service";
import {
    setProjects,
    setSelectedProject,
    addProject,
    updateProjectInList,
    removeProject,
    setLoading,
    setError,
    setPagination,
} from "./projectSlice";
import { toast } from "react-toastify";

// Add these new actions

// FETCH ALL PROJECTS FOR ADMIN
export const fetchAllProjectsAdminAction = (page = 1, limit = 10, filters = {}) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        dispatch(setError(null));

        let url = `/project/admin?page=${page}&limit=${limit}`;
        Object.keys(filters).forEach(key => {
            if (filters[key]) {
                url += `&${key}=${encodeURIComponent(filters[key])}`;
            }
        });

        const response = await getMethod(url);

        if (response.success) {
            dispatch(setProjects(response.data || []));
            if (response.pagination) {
                dispatch(setPagination(response.pagination));
            }
            return { success: true, data: response.data };
        } else {
            dispatch(setError(response.message || "Failed to fetch projects"));
            return { success: false, message: response.message };
        }
    } catch (error) {
        const message = error?.response?.data?.message || "Unable to fetch projects";
        dispatch(setError(message));
        return { success: false, message };
    } finally {
        dispatch(setLoading(false));
    }
};

// FETCH PROJECT BY ID FOR ADMIN
export const fetchProjectByIdAdminAction = (id) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        dispatch(setError(null));

        const response = await getMethod(`/project/admin/${id}`);

        if (response.success) {
            dispatch(setSelectedProject(response.data));
            return { success: true, data: response.data };
        } else {
            dispatch(setError(response.message || "Failed to fetch project"));
            return { success: false, message: response.message };
        }
    } catch (error) {
        const message = error?.response?.data?.message || "Unable to fetch project";
        dispatch(setError(message));
        return { success: false, message };
    } finally {
        dispatch(setLoading(false));
    }
};

// FETCH PROJECT BY ID
export const fetchProjectByIdAction = (id) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        dispatch(setError(null));

        const response = await getMethod(`/project/admin/${id}`);

        if (response.success) {
            dispatch(setSelectedProject(response.data));
            return { success: true, data: response.data };
        } else {
            dispatch(setError(response.message || "Failed to fetch project"));
            return { success: false, message: response.message };
        }
    } catch (error) {
        const message = error?.response?.data?.message || "Unable to fetch project";
        dispatch(setError(message));
        return { success: false, message };
    } finally {
        dispatch(setLoading(false));
    }
};

// UPDATE PROJECT
export const updateProjectAction = (id, data) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        dispatch(setError(null));

        const response = await putMethod(`/project/${id}`, data);

        if (response.success) {
            dispatch(updateProjectInList(response.data));
            toast.success(response.message || "Project updated successfully");
            return { success: true, data: response.data };
        } else {
            toast.error(response.message || "Failed to update project");
            return { success: false, message: response.message };
        }
    } catch (error) {
        const message = error?.response?.data?.message || "Unable to update project";
        toast.error(message);
        return { success: false, message };
    } finally {
        dispatch(setLoading(false));
    }
};

// DELETE PROJECT
export const deleteProjectAction = (id) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        dispatch(setError(null));

        const response = await deleteMethod(`/project/${id}`, {});

        if (response.success) {
            dispatch(removeProject(id));
            toast.success(response.message || "Project deleted successfully");
            return { success: true };
        } else {
            toast.error(response.message || "Failed to delete project");
            return { success: false, message: response.message };
        }
    } catch (error) {
        const message = error?.response?.data?.message || "Unable to delete project";
        toast.error(message);
        return { success: false, message };
    } finally {
        dispatch(setLoading(false));
    }
};

// PERMANENTLY DELETE PROJECT
export const permanentlyDeleteProjectAction = (id) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        dispatch(setError(null));

        const response = await deleteMethod(`/project/permanent-delete/${id}`, {});

        if (response.success) {
            dispatch(removeProject(id));
            toast.success(response.message || "Project permanently deleted successfully");
            return { success: true };
        } else {
            toast.error(response.message || "Failed to permanently delete project");
            return { success: false, message: response.message };
        }
    } catch (error) {
        const message = error?.response?.data?.message || "Unable to permanently delete project";
        toast.error(message);
        return { success: false, message };
    } finally {
        dispatch(setLoading(false));
    }
};

// RESTORE PROJECT
export const restoreProjectAction = (id) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        dispatch(setError(null));

        const response = await putMethod(`/project/restore/${id}`, {});

        if (response.success) {
            toast.success(response.message || "Project restored successfully");
            return { success: true };
        } else {
            toast.error(response.message || "Failed to restore project");
            return { success: false, message: response.message };
        }
    } catch (error) {
        const message = error?.response?.data?.message || "Unable to restore project";
        toast.error(message);
        return { success: false, message };
    } finally {
        dispatch(setLoading(false));
    }
};